import AbstractController from "../../../../../vendors/services/abstractController";
import EventoService from "../../../../services/evento.service";
import { useState } from "react";

export default class SessaoPresencialController extends AbstractController {
  private eventoService: EventoService;
  public lista: any;
  public setLista: any;

  constructor() {
    super();
    [this.lista, this.setLista] = useState([]);
    this.eventoService = new EventoService();
  }

  init() {
    super.init();
    const user = this.getUser();
    if (!!user && !!user.contribuinte && !!user.contribuinte.codContribuinte) {
      this.obterSessaoPresencial(this.getId());
    } else {
      this.obterSessaoPresencialSemLogin(this.getId());
    }
  }

  obterSessaoPresencial(cdContribuicao: any) {
    this.start();
    this.eventoService
      .getSessaoPresencial(cdContribuicao, this.getCodContribuinte())
      .then((res: any) => {
        this.stop();
        if (!!res.result && res.result.length > 0) {
          this.setLista(res.result);
        }
      })
      .catch((err) => {
        console.log("erro", err);
        this.stop();
      });
  }

  obterSessaoPresencialSemLogin(cdContribuicao: any) {
    this.start();
    this.eventoService
      .getSessaoPresencialSemLogin(cdContribuicao)
      .then((res: any) => {
        this.stop();
        if (!!res.result && res.result.length > 0) {
          this.setLista(res.result);
        }
      })
      .catch((err) => {
        console.log("erro", err);
        this.stop();
      });
  }
}
